import React, { DetailedHTMLProps, HTMLAttributes } from 'react';

export interface VoxelTableProps
  extends DetailedHTMLProps<HTMLAttributes<HTMLTableElement>, HTMLTableElement> {
  padding?: string;
  shadow?: string;
  className?: string;
}

export const VoxelTable: React.FC<VoxelTableProps> = ({
  children,
  padding = 'p-0',
  shadow = 'shadow-sm',
  className,
  ...tableProps
}) => {
  return (
    <table className={`w-full border-collapse ${className}`} {...tableProps}>
      {children}
    </table>
  );
};

export default VoxelTable;
